<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="dedication">
<p class="paraNoIndentBB1"><em class="italic">“Now this is no shit,</em></p>
<p class="paraNoIndentBB"><em class="italic">There I was, 10,000 feet,</em></p>
<p class="paraNoIndentBB"><em class="italic">I had a pocket full of nickels and</em></p>
<p class="paraNoIndentBB"><em class="italic">There wasn’t a soft drink machine for miles,</em></p>
<p class="paraNoIndentBB"><em class="italic">So I turned to my copilot and said, ‘Alice,’</em></p>
<p class="paraNoIndentBB"><em class="italic">When all of a sudden, there was Plexiglass flying everywhere.</em></p>
<p class="paraNoIndentBB"><em class="italic">The men, they were scared, but not me.</em></p>
<p class="paraNoIndentBB"><em class="italic">Down below us we saw a man on a bicycle.</em></p>
<p class="paraNoIndentBB"><em class="italic">We knew he was going to church,</em></p>
<p class="paraNoIndentBB"><em class="italic">Because it was Sunday.</em></p>
<p class="paraNoIndentBB"><em class="italic">So, we rolled in on him.</em></p>
<p class="paraNoIndentBB"><em class="italic">It was ten to one!</em></p>
<p class="paraNoIndentBB"><em class="italic">But we finally got that little SOB”</em></p>
<p class="paraNoIndentBB" style="margin-top: 3%;">—Typical flying war story, circa 1971</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_dedication.vue?49827228